import ProgressiveImage from "./ProgressiveImage";
import HeroImage from "./HeroImage";

export { ProgressiveImage, HeroImage };



// WEBPACK FOOTER //
// ./src/components/Image/index.js